export const Show = "show"
export const Message = "message"
export const Type = "type"
export const TimeOut = "timeout"

const state = {
    [Show] : false,
    [Message] : "",
    [Type] : "",
    [TimeOut] : "",
}

const getters={
    isShow(state) {
        return state[Show];
    },
    [Message](state){
        return state[Message]
    },
    [TimeOut](state){
        return state[TimeOut]
    },
    [Type](state){
        return state[Type]
    }
}

const mutations = {
    [Show](state, value){
        state[Show] = value;
    },
    [Message](state, value){
        state[Message] = value;
    },
    [Type](state, value){
        state[Type] = value;
    },
    [TimeOut](state, value){
        state[TimeOut] = value;
    }
}

const actions = {
    [Show](context, value){
        context.commit(Show, !!value)
    },

    [Message](context, value){
        context.commit(Message, value)
    },

    [Type](context, value){
        context.commit(Type, value)
    },

    [TimeOut](context, value){
        context.commit(TimeOut, value)
    }
}

export default {
    namespaced : true,
    actions,
    getters,
    state,
    mutations
}